import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import './App.scss';

declare module '@mui/material/styles' {
  interface Palette {
    neutral: Palette['primary'];
  }

  // allow configuration using `createTheme`
  interface PaletteOptions {
    neutral?: PaletteOptions['primary'];
  }
}

// Update the Button's color prop options
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    neutral: true;
  }
}

export default function ThemeManager(props: any) {
  const dispatch = useDispatch();
  const redux = useSelector((state: any) => state.redux);
  // A custom theme for this app
  const themeState = redux.app.default_theme;
  const mainPrimaryColor = themeState == 'dark' ? '#A20016' : '#A20016';
  const mainSecondaryColor = themeState == 'dark' ? '#f02849' : '#f02849';

  const theme = createTheme({
    typography: {
      fontFamily: 'Outfit, Arial, sans-serif',
    },
    palette: {
      mode: themeState == 'dark' ? 'dark' : 'light',

      primary: {
        main: mainPrimaryColor,
      },
      // info: {
      //   main: infoColor,
      // },
    },
    // shape: {
    //   borderRadius: 32,
    // },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '1.5rem',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: '1.5rem',
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            borderRadius: '1.5rem',
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: '1.5rem',
          },
          notchedOutline: {
            borderRadius: '1.5rem',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            // borderRadius: '1.5rem',
          },
        },
      },
      MuiList: {
        styleOverrides: {
          root: {
            borderRadius: '1.5rem',
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: '1.5rem',
          },
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            borderRadius: '1.5rem',
          },
        },
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      {props.children}
    </ThemeProvider>
  );
}
